import * as React from 'react';
import { createIllustration } from '@balance-web/illustration';

import { describeWithOptions } from './describeWithOptions';

export const AmexLogoName = 'AmexLogo';
export const AmexLogoDescription = 'Amex Credit Card Logo';

export const AmexLogo = createIllustration(
  describeWithOptions(AmexLogoName, AmexLogoDescription, 24, 16),
  <>
    <path
      d="M22 0H2C0.89543 0 0 0.89543 0 2V14C0 15.1046 0.89543 16 2 16H22C23.1046 16 24 15.1046 24 14V2C24 0.89543 23.1046 0 22 0Z"
      fill="#016FD0"
    />
    <path
      clipRule="evenodd"
      d="M13.7642 13.3939V7.6925L23.9117 7.70161V9.27651L22.7388 10.5299L23.9117 11.7948V13.4031H22.0391L21.0439 12.3049L20.0558 13.4072L13.7642 13.3939Z"
      fill="#FFFFFE"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.4419 12.7688V8.31995H18.2142V9.34483H15.6633V10.0405H18.1534V11.0483H15.6633V11.7317H18.2142V12.7688H14.4419Z"
      fill="#016FD0"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M18.1954 12.7687L20.2827 10.5417L18.1953 8.31995H19.811L21.0865 9.72998L22.3656 8.31995H23.9117V8.35495L21.8689 10.5417L23.9117 12.7056V12.7687H22.35L21.0519 11.3446L19.7671 12.7687H18.1954Z"
      fill="#016FD0"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.2374 2.63196H16.6834L17.5426 4.58281V2.63196H20.5624L21.0832 4.09353L21.6057 2.63196H23.9116V8.33335H11.7251L14.2374 2.63196Z"
      fill="#FFFFFE"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M14.7006 3.25134L12.7266 7.69651H14.0805L14.4529 6.80635H16.4708L16.843 7.69651H18.2306L16.2648 3.25134H14.7006ZM14.8702 5.80878L15.4622 4.39371L16.0538 5.80878H14.8702Z"
      fill="#016FD0"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M18.2119 7.69569V3.25061L20.115 3.25715L21.0943 5.98988L22.0799 3.25061H23.9115V7.69569L22.7329 7.70612V4.65278L21.6204 7.69569H20.5446L19.4089 4.64235V7.69569H18.2119Z"
      fill="#016FD0"
      fillRule="evenodd"
    />
  </>
);
